import React, { useState } from "react";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainLayout from "../components/MainLayout";
import { cancellationHeaders } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
const Cancellation = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [formFields, setFormFields] = useState({ date: "" });

  const [errors, setErrors] = useState({
    date: "",
  });

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (value.trim() === "") {
      const formattedName = name.charAt(0).toUpperCase() + name.slice();
      error = `${formattedName} is required`;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const handleFieldsChange = (value, name) => {
    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
  };

  const cancel = async () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setFormFields({
      date: "",
      guestName: "",
      bookingReferenceNumber: "",
      originalAmountCharged: "",
      cancellationFee: "",
      refundAmount: "",
      incomeFromCancellation: "",
      paymentStatus: "",
      invoiceNumber: "",
    });
    setFormFieldsError({
      villaNameError: "",
      villaTypeError: "",
      locationError: "",
      maximumOccpancyError: "",
      areaError: "",
      aminitiesError: "",
      tariffError: "",
    });
  };

  const [formFieldsError, setFormFieldsError] = useState({
    paymentStatusError: "",
  });

  const [paymentStatusDD, setpaymentStatusDD] = useState([
    { value: 1, label: "Online" },
    { value: 2, label: "UPI" },
    { value: 3, label: "Cash" },
  ]);

  return (
    <MainLayout pageName={"3"}>
      {visibleTable && (
        <GridPage
          title="Cancellation"
          header={cancellationHeaders}
          // records={bindRoleMasterDatas}
          // handleEdit={handleEdit}
          // handleAction={handlevilla}
          showAdd={showAdd}
          // blockView={false}
        />
      )}
      {visibleAdd && (
        <>
          <div>
            <AddScreenTitle
              title="Cancellation"
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
            />
          </div>
          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <form className={mainTable.formForClientMaster}>
                <div className={mainTable.grid3}>
                  <InputText
                    inputType="date"
                    title="Cancellation Date"
                    classStar="text-red-500"
                    name="date"
                    disabled={false}
                    content={formFields.date}
                    controlFunc={(e) =>
                      setFormFields({ ...formFields, date: e.target.value })
                    }
                    controlFuncBlur={handleBlur}
                    errorMessage={errors.date}
                    inputClassName="w-1/4"
                  />
                  <InputText
                    title="Guest Name"
                    inputType="text"
                    name="guestName"
                    placeholder="GuestName"
                    // tabIndex="1"
                    maxLength={50}
                  />
                  <InputText
                    title="Booking Reference Number"
                    inputType="text"
                    name="bookingReferenceNumber"
                    placeholder="BookingReferenceNumber"
                    // tabIndex="1"
                    maxLength={50}
                  />
                  <InputText
                    title="Original Amount Charged"
                    inputType="text"
                    name="originalAmountCharged"
                    placeholder="OriginalAmountCharged"
                    // tabIndex="1"
                    maxLength={50}
                  />
                  <InputText
                    title="Cancellation Fees"
                    inputType="text"
                    name="cancellationFee"
                    placeholder="CancellationFee"
                    // tabIndex="1"
                    maxLength={50}
                  />
                  <InputText
                    title="Refund Amount"
                    inputType="text"
                    name="refundAmount"
                    placeholder="RefundAmount"
                    // tabIndex="1"
                    maxLength={50}
                  />
                  <InputText
                    title="Income From Cancellation"
                    inputType="text"
                    name="incomeFromCancellation"
                    placeholder="IncomeFromCancellation"
                    // tabIndex="1"
                    maxLength={50}
                  />
                  <AutoDropDown
                    selectedOption={paymentStatusDD.find(
                      (x) => x.value == formFields.paymentStatus
                    )}
                    title="Payment Status"
                    inputType="dropdown"
                    options={paymentStatusDD}
                    name="paymentStatus"
                    controlFunc={(value, e) => {
                      handleFieldsChange(value.value, e.name);
                    }}
                    controlFuncBlur={() => {
                      setFormFieldsError({
                        ...formFields,
                        paymentStatusError: formFields.paymentStatus
                          ? ""
                          : "Select Payment Status",
                      });
                    }}
                    errorMessage={formFieldsError.paymentStatusError}
                    placeholder="PaymentStatus"
                    Class="custom-class"
                    //classStar={"text-red-500"}
                    // tabIndex="1"
                    maxLength={50}
                  />
                  {/* <AutoDropDown
        title="Payment Method"
        inputType="dropdown"
        name="paymentMethod"
        placeholder="PaymentMethod"
        // tabIndex="1"
        maxLength={50}
      />
      <AutoDropDown
        title="Refund Status"
        inputType="dropdown"
        name="refundStatus"
        placeholder="RefundStatus"
        // tabIndex="1"
        maxLength={50}
      />
      <AutoDropDown
        title="Cancellation Reason"
        inputType="dropdown"
        name="cancellationReason"
        placeholder="CancellationReason"
        // tabIndex="1"
        maxLength={50}
      /> */}
                  <InputText
                    title="Invoice Number"
                    inputType="text"
                    name="invoiceNumber"
                    placeholder="InvoiceNumber"
                    // tabIndex="1"
                    maxLength={50}
                  />
                </div>
              </form>
              <Buttons
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                //handleSubmit={handleSubmit}
                cancel={cancel}
                // disabledBtn={submitBtnDisabled ? true : false}
              />
            </div>
          </div>
        </>
      )}
    </MainLayout>
  );
};
export default Cancellation;
